import { Component, OnInit } from '@angular/core';
import * as jspdf from 'jspdf';
import html2canvas from 'html2canvas';
import { GLOBAL } from 'src/app/services/global';
@Component({
  selector: 'page-formulario15',
  templateUrl: './formulario15.component.html',
  styleUrls: ['./formulario15.component.css']
})
export class Formulario15Component implements OnInit {
  public nombreMuni = GLOBAL.nombreMuni;
  public region = GLOBAL.region;
  public cip;
  public propiedad;
  public registro_bienes;
  public declaracion;
  public propietarios;
  public representantes;
  public permiso_notariado;
  public empresas;
  public arquitectos;
  public constructores;
  public constructora;
  public antecedentes;
  public ampliacion;


  //listas filtros

  public perm_pri = [];
  public ampliaciones = [];
  public recep = [];
  
  pages = [1,2,3];
  constructor() {

    //ANTECEDENTES
    if (JSON.parse(localStorage.getItem("antecedentes")).length > 0){
      this.antecedentes = JSON.parse(localStorage.getItem("antecedentes"))
    }
    else { 
      localStorage.setItem("antecedentes", JSON.stringify([]))
      this.antecedentes = [{tipo_permiso:'',permiso:'',numero:0,fecha:null,superficie:0}] 
    }

    


      if(this.antecedentes.length > 0){
        for (let i = 0; i < this.antecedentes.length; i++) {
          
          if(this.antecedentes[i].tipo_permiso == "Permiso Primitivo"){
            this.perm_pri.push(this.antecedentes[i]);
          }
          else if(this.perm_pri.length == 0 && this.antecedentes.length == (i+1)){
            this.perm_pri = [{tipo_permiso:'',permiso:'',numero:null,fecha:null,superficie:null}];

          }
          if(this.antecedentes[i].tipo_permiso == "Modificaciones y Ampliaciones"){
            this.ampliaciones.push(this.antecedentes[i]);

          }
          else if(this.ampliaciones.length == 0 && this.antecedentes.length == (i+1)){
            this.ampliaciones = [{tipo_permiso:'',permiso:'',numero:null,fecha:null,superficie:null},
                                {tipo_permiso:'',permiso:'',numero:null,fecha:null,superficie:null},
                                {tipo_permiso:'',permiso:'',numero:null,fecha:null,superficie:null}];
          }
          if(this.antecedentes[i].tipo_permiso == "Recepcion"){
            this.recep.push(this.antecedentes[i]);

          }
          else if( this.recep.length == 0 && this.recep.length == (i+1)){
            this.recep =  [{tipo_permiso:'',permiso:'',numero:null,fecha:null,superficie:null},
                          {tipo_permiso:'',permiso:'',numero:null,fecha:null,superficie:null},
                          {tipo_permiso:'',permiso:'',numero:null,fecha:null,superficie:null},
                          {tipo_permiso:'',permiso:'',numero:null,fecha:null,superficie:null}];
          }
        }

        if(this.ampliaciones.length > 0 && this.ampliaciones.length < 3){
          for (let x = this.ampliaciones.length ; x < 3; x++) {
            this.ampliaciones.push({tipo_permiso:'',permiso:'',numero:null,fecha:null,superficie:null})
          }
        }
        if(this.recep.length > 0 && this.recep.length < 4){
          for (let x = this.recep.length ; x < 4; x++) {
            this.recep.push({tipo_permiso:'',permiso:'',numero:null,fecha:null,superficie:null})
          }
        }

      }
      else{
        this.perm_pri = [{tipo_permiso:'',permiso:'',numero:null,fecha:null,superficie:null},];
        this.ampliaciones = [{tipo_permiso:'',permiso:'',numero:null,fecha:null,superficie:null},
                            {tipo_permiso:'',permiso:'',numero:null,fecha:null,superficie:null},
                            {tipo_permiso:'',permiso:'',numero:null,fecha:null,superficie:null}];
        this.recep =  [{tipo_permiso:'',permiso:'',numero:null,fecha:null,superficie:null},
                      {tipo_permiso:'',permiso:'',numero:null,fecha:null,superficie:null},
                      {tipo_permiso:'',permiso:'',numero:null,fecha:null,superficie:null},
                      {tipo_permiso:'',permiso:'',numero:null,fecha:null,superficie:null}];
      }

      this.ngAfterContentInit();
   }

  ngOnInit() {
  }

  ngAfterContentChecked(){
    this.ngAfterContentInit();
  }

  ngAfterContentInit() {

    //CIP
    if(JSON.parse(localStorage.getItem("cip"))){
      if (JSON.parse(localStorage.getItem("cip")).length > 0){ 
        this.cip = JSON.parse(localStorage.getItem("cip"));
      }else{
        localStorage.setItem("cip", JSON.stringify([]))
        this.cip = [{certcip: '' ,fecha_cip: null}]
      }
    }
    
    //REGISTRO
    if(JSON.parse(localStorage.getItem("registro_bienes"))){
      if (JSON.parse(localStorage.getItem("registro_bienes")).length > 0){ 
        this.registro_bienes = JSON.parse(localStorage.getItem("registro_bienes"));
      }else{
      localStorage.setItem("registro_bienes", JSON.stringify([]))
        this.registro_bienes = [{inscrito: '', numero: '', anio: '', bienes: ''}]
      }
    }
    
    //PROPIEDAD
    if(JSON.parse(localStorage.getItem("propiedad"))){
      if (JSON.parse(localStorage.getItem("propiedad")).length > 0){ 
        this.propiedad = JSON.parse(localStorage.getItem("propiedad"));
      }else{
       localStorage.setItem("propiedad", JSON.stringify([]))
        this.propiedad = [{rol: '', id_direcc: '', folio: '', calle: '', calle_num: 0, direccion_completa:'', direc_complemento:'', direc_compl_num:'', loteo:'', manzana:'', plano:'', recordId:''}]
      }
    }    

    //DECLARACION
    if(JSON.parse(localStorage.getItem("declaracion"))){
      if (JSON.parse(localStorage.getItem("declaracion")).length > 0){ 
        this.declaracion = JSON.parse(localStorage.getItem("declaracion"));
      }else{
        localStorage.setItem("declaracion", JSON.stringify([]))
        this.declaracion = [{plano:'',denominado:'',elaborado:'',profesion:''}]
      }
    }    


    //PROPIETARIOS
    if(JSON.parse(localStorage.getItem("propietarios"))){
      if (JSON.parse(localStorage.getItem("propietarios")).length > 0){
        this.propietarios = JSON.parse(localStorage.getItem("propietarios"));
     }else{
        localStorage.setItem("propietarios", JSON.stringify([]))
        this.propietarios = [{rut: '', nombre: '',  apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '',  comuna: '', fono: '', fax: '', mail: '',recordId: ''}]
     }
    }

     //REPRESENTANTE
     if(JSON.parse(localStorage.getItem("representantes"))){
      if (JSON.parse(localStorage.getItem("representantes")).length > 0){ 
        this.representantes = JSON.parse(localStorage.getItem("representantes")); //no es obligatorio pero si tiene informacion debe estar permiso_notariado obligatoriamente
      }else{
        localStorage.setItem("representantes", JSON.stringify([]))
        this.representantes = [{rut: '', nombre: '',  apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '',  comuna: '', fono: '', fax: '', mail: '',recordId: ''}]
      }
    }

    //PERMISO NOTARIADO
    if(JSON.parse(localStorage.getItem("permiso_notariado"))){
      if (JSON.parse(localStorage.getItem("permiso_notariado")).length > 0){
        this.permiso_notariado = JSON.parse(localStorage.getItem("permiso_notariado"));
      }else{
       localStorage.setItem("permiso_notariado", JSON.stringify([]))
        this.permiso_notariado = [{acreditacion:'', fecha:null, escritura:null, notario:''}]
      }
    }

    //EMPRESAS
    if(JSON.parse(localStorage.getItem("empresas"))){
      if (JSON.parse(localStorage.getItem("empresas")).length > 0){
        this.empresas = JSON.parse(localStorage.getItem("empresas"))
      } else {
        localStorage.setItem("empresas", JSON.stringify([]))
        this.empresas = [{rut: '',nombre:'', direccion: '', direccion_num:'', direccion_complemento:'', direccion_completa:'',comuna:'',fono:'', fax:'', mail:'', recordId:''}]
      }
    }
    
     //ARQUITECTOS
     if(JSON.parse(localStorage.getItem("arquitectos"))){
      if (JSON.parse(localStorage.getItem("arquitectos")).length > 0){
        this.arquitectos = JSON.parse(localStorage.getItem("arquitectos"))
      }else{ 
       localStorage.setItem("arquitectos", JSON.stringify([]))
        this.arquitectos = [{rut: '', nombre:'', mail:'', apellido_mat:'', apellido_pat:'', direccion: '', direccion_complemento:'', direccion_num:'', comuna:'', fono:'', fax:'',  patente:'', recordId:''}]
      }
    }
    
   //CONSTRUCTORA
   if(JSON.parse(localStorage.getItem("constructora"))){
    if (JSON.parse(localStorage.getItem("constructora")).length > 0){
      this.constructora = JSON.parse(localStorage.getItem("constructora"))
    }else{ 
      localStorage.setItem("constructora", JSON.stringify([]))
        this.constructora = [{rut: '', nombre:'', direccion: '', direccion_num:'', direccion_complemento:'', direccion_completa:'', comuna:'', fono:'', fax:'', mail:'', patente:'', recordId:''}]
    }
   }  

    //CONSTRUCTORES 
    if(JSON.parse(localStorage.getItem("constructores"))){
      if (JSON.parse(localStorage.getItem("constructores")).length > 0){
        this.constructores = JSON.parse(localStorage.getItem("constructores"))
      }else{ 
        localStorage.setItem("constructores", JSON.stringify([]))
        this.constructores = [{rut: '', nombre:'', mail:'', apellido_mat:'', apellido_pat:'', direccion: '', direccion_complemento:'', direccion_num:'', comuna:'', fono:'', fax:'', patente:'', recordId:''}]
      }
    }
    
    //ANTECEDENTES
    if(JSON.parse(localStorage.getItem("antecedentes"))){
      if (JSON.parse(localStorage.getItem("antecedentes")).length > 0){
        this.antecedentes = JSON.parse(localStorage.getItem("antecedentes"))
      } else { 
        localStorage.setItem("antecedentes", JSON.stringify([]))
        this.antecedentes = [{tipo_permiso:'',permiso:'',numero:0,fecha:null,superficie:0}] 
      }
    }

    //AMPLIACION
    if(JSON.parse(localStorage.getItem("ampliacion"))){
      if (JSON.parse(localStorage.getItem("ampliacion")).length > 0){ 
        this.ampliacion = JSON.parse(localStorage.getItem("ampliacion"))
      } else { 
        localStorage.setItem("ampliacion", JSON.stringify([]))
        this.ampliacion = [{sup_permiso:0,superf_terreno:0,piso1_ex:0,piso1_amp:0,piso2_ex:0,piso2_amp:0,piso3_ex:0,piso3_amp:0,superf_amp:0,condominio:"",economica:""}] 
      }
    }
    
    

  }
  captureScreen(){
    var pdf = new jspdf('p', 'mm', 'a4');

    html2canvas(document.getElementById(`page1`)).then(canvas => {
       const contentDataURL = canvas.toDataURL('image/png')
       pdf.addImage(contentDataURL, 'PNG', 5, 5, 200, 297)      
    });

    html2canvas(document.getElementById(`page2`)).then(canvas => {
      const contentDataURL = canvas.toDataURL('image/png')
      pdf.addPage();
      pdf.addImage(contentDataURL, 'PNG', 5, 5, 200, 297)      
    });
    html2canvas(document.getElementById(`page3`)).then(canvas => {
      const contentDataURL = canvas.toDataURL('image/png')
      pdf.addPage();
      pdf.addImage(contentDataURL, 'PNG', 5, 5, 200, 297)  
    });

    setTimeout(() =>{
      pdf.save(this.propietarios[0].rut+'.pdf')
     // pdf.save('prueba.pdf')
    },6000)
   }

}
